import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FlexLayoutModule } from '@angular/flex-layout'
import { ReactiveFormsModule } from '@angular/forms'
import { MatButtonModule } from '@angular/material/button'
import { MatCheckboxModule } from '@angular/material/checkbox'
import { MatDialogModule } from '@angular/material/dialog'
import { MatInputModule } from '@angular/material/input'
import { MatProgressBarModule } from '@angular/material/progress-bar'
import { MatSelectModule } from '@angular/material/select'
import { MatTableModule } from '@angular/material/table'
import { PipesModule } from '@mmx/pipes'
import { TranslateModule } from '@ngx-translate/core'

import { DateFieldModule } from '../date-selector'
import { ReferrerSelectorModule } from '../referrer-selector'
import { ServiceReviewInquiryDialogComponent, ServiceReviewInquiryFormComponent, ServiceReviewListComponent } from './components'

const components = [
  ServiceReviewListComponent,
  ServiceReviewInquiryDialogComponent,
  ServiceReviewInquiryFormComponent,
]

@NgModule({
  imports: [
    CommonModule,
    DateFieldModule,
    FlexLayoutModule,
    MatButtonModule,
    MatCheckboxModule,
    MatDialogModule,
    MatInputModule,
    MatProgressBarModule,
    MatSelectModule,
    MatTableModule,
    PipesModule,
    ReactiveFormsModule,
    TranslateModule,
    ReferrerSelectorModule,
  ],
  declarations: [
    ...components,
  ],
  exports: [
    ...components,
  ],
})
export class ServiceReviewInquiryModule {}
